import classNames from "classnames";
import styles from "./index.module.less";
import dateLeftSVG from "./date_left.svg";
import dateRightSVG from "./date_right.svg";
import { Flex } from "antd";
import { isMobile } from "@/utils";

export interface P4CardProps {
  date: string;
  title: any;
  source: string;
  icon: string;
  mobileSourceText1?: string;
  mobileSourceText2?: string;
}
const P4Card = ({
  date,
  title,
  source,
  icon,
  mobileSourceText1,
  mobileSourceText2,
}: P4CardProps) => {
  return (
    <div
      className={classNames(styles.p4Card, {
        [styles.isMobile]: isMobile(),
      })}
    >
      <div className={styles.icon}>
        <img src={icon} alt={title} />
      </div>
      <Flex align="center" className={styles.date}>
        <img src={dateLeftSVG} />
        {date}
        <img src={dateRightSVG} />
      </Flex>
      <div className={styles.title}>{title}</div>
      <div className={styles.source}>
        {mobileSourceText1 ? (
          <>
            <span>{mobileSourceText1}</span><br/>
            <span>{mobileSourceText2}</span>
          </>
        ) : (
          source
        )}
      </div>
    </div>
  );
};
export default P4Card;
